import { render, staticRenderFns } from "./RepresentativeTransfers.vue?vue&type=template&id=ac3849e8&"
import script from "./RepresentativeTransfers.vue?vue&type=script&lang=js&"
export * from "./RepresentativeTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports